import React from "react";
import {
    Radio as BaseRadio,
    RadioGroup as BaseRadioGroup,
    Label,
    RadioGroupProps,
    RadioProps,
    Text,
    composeRenderProps,
} from "react-aria-components";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { RichText } from "../RichText";
import { FieldError, FieldProps } from "./common";

import styles from "./inputs.module.scss";

export function Radio({ children, className, ...props }: RadioProps) {
    return (
        <BaseRadio
            {...props}
            className={composeRenderProps(className, (cn) =>
                concatClassNames([cn, styles.fieldWrapper]),
            )}
        >
            {composeRenderProps(children, (children, _) => (
                <>
                    <span className={styles.radio} />
                    {children}
                </>
            ))}
        </BaseRadio>
    );
}

export function RadioGroup({
    label,
    description,
    errorMessage,
    children,
    className,
    ...props
}: FieldProps & RadioGroupProps) {
    return (
        <BaseRadioGroup
            {...props}
            className={composeRenderProps(className, (cn) =>
                concatClassNames([cn, styles.fieldGroup]),
            )}
            isInvalid={errorMessage ? true : undefined}
        >
            {composeRenderProps(children, (children) => (
                <>
                    {description && (
                        <Text slot="description">
                            <RichText value={description} />
                        </Text>
                    )}
                    {label && (
                        <Label className={styles.groupLabel}>{label}</Label>
                    )}
                    {children}
                    <FieldError>{errorMessage}</FieldError>
                </>
            ))}
        </BaseRadioGroup>
    );
}
